import React, { Fragment } from 'react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';

const LayoutDefault = ({ component: Component, ...rest }) => (
  <Fragment>
    <div
      {...rest}
      className='text-gray-900 transition-all bg-white dark:bg-gray-900 dark:text-white'
    >
      <Navbar />
      <div className='max-w-4xl px-4 mx-auto'>
        <Component />
      </div>
      <Footer />
    </div>
  </Fragment>
);

export default LayoutDefault;
